<template>
  <data-chip
    :text="statusText(status)"
    :color="statusColor(status)"
    :small="small"
  >
  </data-chip>
</template>

<script>
import DataChip from "@/components/_systemwide/DataChip.vue";
import {
  getPersonnelStatusText,
  getPersonnelStatusColor,
} from "@/util/personnel-records.js";

export default {
  name: "personnel-record-status-chip",
  components: {
    DataChip,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    statusText(statusId) {
      return getPersonnelStatusText(statusId);
    },
    statusColor(status) {
      return getPersonnelStatusColor(status);
    },
  },
};
</script>
